import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { PageHead } from "../components/ui";
import { useMe } from "../session";
import { Categories } from "./settings/Categories";
import { Counterparties } from "./settings/Counterparties";
import { MemoRules } from "./settings/MemoRules";

/** Cadastros: tudo o que se cria uma vez e se reutiliza nos lançamentos (categorias, beneficiários e pagadores, regras de memorização). No PJ, centros de custo e clientes/fornecedores são atalhos do mesmo menu. */
export function Registers() {
  const { me } = useMe();
  const base = `/${me.user.realm}/cadastros`;
  const nav = useNavigate();
  const { pathname } = useLocation();
  const tabs: [string, string][] = [["categorias", "Categorias"], ["contrapartes", "Beneficiários e Pagadores"], ["memorizacao", "Memorização"]];
  return (
    <>
      <PageHead title="Cadastros" sub="Categorias, beneficiários e pagadores e regras de memorização." />
      <div className="seg" role="tablist" aria-label="Cadastros" style={{ marginBottom: 16 }}>
        {tabs.map(([k, l]) => { const on = pathname.startsWith(`${base}/${k}`) || (k === "categorias" && pathname === base); return <button key={k} role="tab" aria-selected={on} aria-pressed={on} data-tab={k} onClick={() => nav(`${base}/${k}`)}>{l}</button>; })}
      </div>
      <Routes>
        <Route index element={<Navigate to="categorias" replace />} />
        <Route path="categorias" element={<Categories />} />
        <Route path="contrapartes" element={<Counterparties />} />
        <Route path="memorizacao" element={<MemoRules />} />
        <Route path="*" element={<Navigate to="categorias" replace />} />
      </Routes>
    </>
  );
}
